import React from 'react';
import ResellerCrmPage from './ResellerCrmPage';
import { CRM_CONFIGS } from './resellerCrmShared';

// Lead Store list — Reseller CRM এর একই কোড, শুধু store config দিয়ে।
export default function StoreCrmPage() {
    return <ResellerCrmPage config={CRM_CONFIGS.store} />;
}
